import { render, staticRenderFns } from "./StudentCreate.vue?vue&type=template&id=efbf9486"
import script from "../../controllers/student/student-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/student/student-create.js?vue&type=script&lang=js&external"
import style0 from "./StudentCreate.vue?vue&type=style&index=0&id=efbf9486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports